import { render, staticRenderFns } from "./courseDetails.vue?vue&type=template&id=b77bf354&scoped=true&"
import script from "./courseDetails.vue?vue&type=script&lang=js&"
export * from "./courseDetails.vue?vue&type=script&lang=js&"
import style0 from "./courseDetails.vue?vue&type=style&index=0&id=b77bf354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77bf354",
  null
  
)

export default component.exports